// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/fonts/UnileverDesire-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../assets/images/DropdownArrow.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Unilever Desire";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-weight: normal;
  font-style: normal; }

.LandingHeader_mainHeader__iqQt9 {
  position: fixed;
  z-index: 9999;
  width: 100%;
  top: 0px;
  display: contents; }

.LandingHeader_mainHeaderPassive__6ljlN {
  pointer-events: none; }

.LandingHeader_header__WSYV4 {
  width: 100%;
  background-color: #FFFFFF;
  border-bottom: 1px solid #E2E8F0;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1), 0px 1px 2px -1px rgba(0, 0, 0, 0.1); }

.LandingHeader_countryName__8zo6U {
  display: flex;
  align-items: center;
  gap: 6px; }
  .LandingHeader_countryName__8zo6U .LandingHeader_name__o8YpM {
    font-family: "Unilever Desire", sans-serif;
    font-size: 20px !important;
    font-weight: 400 !important;
    color: #030D14;
    margin-top: 3px !important; }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    .LandingHeader_countryName__8zo6U {
      border-right: 0px; } }
  .LandingHeader_countryName__8zo6U .LandingHeader_countryLogo__z6ise {
    border-radius: 50%;
    width: 22.4px;
    height: 22.4px; }

.LandingHeader_countryNameMbl__I9kfJ {
  border-right: 1px solid #5588F7;
  display: flex;
  align-items: center;
  justify-self: end;
  gap: 8px;
  padding-right: 16px; }
  .LandingHeader_countryNameMbl__I9kfJ .LandingHeader_name__o8YpM {
    font-size: 16px !important;
    font-weight: 400 !important;
    margin-bottom: 5px !important; }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    .LandingHeader_countryNameMbl__I9kfJ {
      border-right: 0px; } }
  .LandingHeader_countryNameMbl__I9kfJ .LandingHeader_countryLogo__z6ise {
    border-radius: 50%; }

.LandingHeader_headertop__Llsv2 {
  height: 68px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center; }
  @media (max-width: 1199px) {
    .LandingHeader_headertop__Llsv2 {
      border-bottom: none;
      height: 68px; } }

.LandingHeader_hamburgerBtn__Mwfze {
  display: none;
  cursor: pointer;
  background: none;
  border: none;
  padding: 8px;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-left: auto;
  margin-right: 16px;
  z-index: 2100; }
  .LandingHeader_hamburgerBtn__Mwfze img {
    width: 24px;
    height: 24px;
    background: #0066CC; }
  @media (max-width: 848px) {
    .LandingHeader_hamburgerBtn__Mwfze {
      display: flex; } }

.LandingHeader_dttReports__xRsOp {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  margin-left: 72px;
  cursor: pointer;
  background: transparent;
  border: 0;
  padding: 0; }
  .LandingHeader_dttReports__xRsOp:focus-visible {
    outline: 2px solid #0066CC;
    outline-offset: 4px;
    border-radius: 8px; }
  .LandingHeader_dttReports__xRsOp .LandingHeader_backArrow__JuNoJ {
    width: 24px;
    height: 24px; }
  @media (max-width: 848px) {
    .LandingHeader_dttReports__xRsOp {
      display: flex;
      margin-left: 16px; } }

.LandingHeader_logoIconContainer__VBQCN {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  background: #0066CC;
  border-radius: 14px;
  flex-shrink: 0; }

.LandingHeader_logoIcon__3CMUf {
  width: 24px;
  height: 24px; }

.LandingHeader_logoText__EGElI {
  height: 51.57px; }
  @media (max-width: 848px) {
    .LandingHeader_logoText__EGElI {
      display: block;
      height: 28px;
      width: auto; } }

.LandingHeader_navlinks__AYEoq, .LandingHeader_menuSide__tWU81 {
  display: flex;
  flex-direction: row;
  align-items: center;
  color: #030D14;
  margin-right: 72px;
  gap: 23px;
  cursor: default; }
  .LandingHeader_navlinks__AYEoq p, .LandingHeader_menuSide__tWU81 p {
    font-size: 14px;
    font-weight: 400;
    margin-bottom: 0px;
    color: #030D14; }
  .LandingHeader_navlinks__AYEoq span, .LandingHeader_menuSide__tWU81 span {
    display: none;
    gap: 8px;
    align-items: center;
    cursor: pointer; }
    .LandingHeader_navlinks__AYEoq span p, .LandingHeader_menuSide__tWU81 span p {
      font-weight: 400;
      font-size: 14px; }
  @media (max-width: 848px) {
    .LandingHeader_navlinks__AYEoq, .LandingHeader_menuSide__tWU81 {
      position: absolute;
      left: -200%;
      visibility: hidden; } }

.LandingHeader_headerDivider__C3BDB {
  display: block !important;
  width: 0px;
  height: 34.76px;
  border-left: 1px solid #CCCFD0;
  flex-shrink: 0; }
  @media (max-width: 848px) {
    .LandingHeader_headerDivider__C3BDB {
      display: none !important; } }

.LandingHeader_profileAvatar__4UIGV {
  cursor: pointer;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  background: transparent;
  border: 0;
  padding: 0; }
  .LandingHeader_profileAvatar__4UIGV:focus-visible {
    outline: 2px solid #0066CC;
    outline-offset: 4px;
    border-radius: 8px; }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    .LandingHeader_profileAvatar__4UIGV {
      display: none; } }
  @media (max-width: 848px) {
    .LandingHeader_profileAvatar__4UIGV {
      display: none; } }

@media (max-width: 848px) {
  .LandingHeader_profileAvatarInMenu__o9wU9 {
    display: flex !important;
    margin-left: auto; } }

.LandingHeader_inlineProfilePanel__jDHXS {
  display: none; }
  @media (max-width: 848px) {
    .LandingHeader_inlineProfilePanel__jDHXS {
      display: flex;
      flex-direction: column;
      width: 100%;
      max-width: 100%;
      margin-top: 12px;
      background: #FFFFFF;
      border: 1px solid #E2E8F0;
      border-radius: 12px;
      box-shadow: 0px 4px 14px rgba(3, 13, 20, 0.08);
      overflow-y: auto;
      overflow-x: hidden;
      -webkit-overflow-scrolling: touch; } }

.LandingHeader_inlineProfileHeader__oQ6x8 {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  background: #F3F7FD; }

.LandingHeader_inlineProfileIcon__Fvts8 {
  width: 36px;
  height: 36px;
  object-fit: contain; }

.LandingHeader_inlineProfileInfo__rxSRL {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0; }
  .LandingHeader_inlineProfileInfo__rxSRL h4 {
    margin: 0;
    font-family: "Unilever Desire", sans-serif;
    font-size: 16px;
    font-weight: 700;
    line-height: 16px;
    color: #030D14; }
  .LandingHeader_inlineProfileInfo__rxSRL p {
    margin: 0;
    font-family: "Unilever Desire", sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 16px;
    color: #333C43;
    overflow: hidden;
    text-overflow: ellipsis; }

.LandingHeader_inlineProfileBody__KQ35m {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  min-width: 280px;
  padding-bottom: 24px; }

.LandingHeader_inlineInfoBlock__8QsNB {
  display: flex;
  flex-direction: column;
  gap: 6px; }

.LandingHeader_inlineTitle__qT9CI {
  margin: 0;
  font-family: "Unilever Desire", sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 16px;
  color: #333C43; }

.LandingHeader_inlineDtAccess__JFPWi {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  align-items: center; }

.LandingHeader_inlineDisplay__aHFej {
  margin: 0;
  font-family: "Unilever Desire", sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  color: #030D14; }

.LandingHeader_inlineToggle__zqGgv {
  margin: 0;
  font-family: "Unilever Desire", sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 16px;
  color: #0066CC;
  cursor: pointer; }

.LandingHeader_inlineLogout__ewIg5 {
  display: flex;
  align-items: center;
  cursor: pointer;
  background: transparent;
  border: 0;
  padding: 0; }
  .LandingHeader_inlineLogout__ewIg5:focus-visible {
    outline: 2px solid #0066CC;
    outline-offset: 4px;
    border-radius: 6px; }
  .LandingHeader_inlineLogout__ewIg5 p {
    margin: 0;
    font-family: "Unilever Desire", sans-serif;
    font-size: 16px;
    font-weight: 600;
    line-height: 16px;
    color: #0066CC; }

.LandingHeader_profileIcon__0IfmL {
  margin-left: 20px; }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    .LandingHeader_profileIcon__0IfmL {
      display: none !important; } }

:root {
  --rt-opacity: 1 !important; }

.LandingHeader_popupModal__rtaTq {
  background-color: #FFFFFF !important;
  border-radius: 8px !important;
  padding: 0 !important;
  width: 294px;
  overflow: hidden;
  box-sizing: border-box;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.16);
  z-index: 4; }
  .LandingHeader_popupModal__rtaTq .styles-module_content__ydYdI {
    padding: 0 !important;
    border-radius: 8px; }
  .LandingHeader_popupModal__rtaTq .LandingHeader_popup__yoe6\\+ {
    width: 294px;
    max-width: 294px;
    min-height: auto;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    cursor: auto !important; }
    .LandingHeader_popupModal__rtaTq .LandingHeader_popup__yoe6\\+ .LandingHeader_popupDetails__dzkjD {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 12px;
      padding: 16px;
      width: 100%;
      max-width: 100%;
      box-sizing: border-box;
      min-height: 69.57px;
      background-color: #F3F7FD; }
    .LandingHeader_popupModal__rtaTq .LandingHeader_popup__yoe6\\+ .LandingHeader_popupUserIcon__A2xoZ {
      width: 37.57px;
      height: 37.57px;
      flex-shrink: 0;
      object-fit: contain; }
    .LandingHeader_popupModal__rtaTq .LandingHeader_popup__yoe6\\+ .LandingHeader_popupUserInfo__zguqT {
      display: flex;
      flex-direction: column;
      gap: 4px; }
      .LandingHeader_popupModal__rtaTq .LandingHeader_popup__yoe6\\+ .LandingHeader_popupUserInfo__zguqT h4 {
        margin: 0;
        font-family: "Unilever Desire", sans-serif;
        font-size: 16px;
        font-weight: 700;
        line-height: 16px;
        color: #030D14; }
      .LandingHeader_popupModal__rtaTq .LandingHeader_popup__yoe6\\+ .LandingHeader_popupUserInfo__zguqT p {
        margin: 0;
        font-family: "Unilever Desire", sans-serif;
        font-size: 14px;
        font-weight: 400;
        line-height: 16px;
        color: #030D14; }
    .LandingHeader_popupModal__rtaTq .LandingHeader_popup__yoe6\\+ .LandingHeader_popupBody__95VGG {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 24px;
      width: 100%;
      padding: 24px 16px;
      box-sizing: border-box; }
    .LandingHeader_popupModal__rtaTq .LandingHeader_popup__yoe6\\+ .LandingHeader_infoBlock__Bnl1S {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 8px;
      width: 100%; }
    .LandingHeader_popupModal__rtaTq .LandingHeader_popup__yoe6\\+ .LandingHeader_title__EGtv1 {
      margin: 0;
      font-family: "Unilever Desire", sans-serif;
      font-size: 16px;
      font-weight: 600;
      line-height: 16px;
      color: #333C43; }
    .LandingHeader_popupModal__rtaTq .LandingHeader_popup__yoe6\\+ .LandingHeader_dtAccess__ov8vb {
      display: flex;
      flex-direction: row;
      gap: 4px;
      align-items: center;
      width: 100%;
      color: #333C43; }
      .LandingHeader_popupModal__rtaTq .LandingHeader_popup__yoe6\\+ .LandingHeader_dtAccess__ov8vb .LandingHeader_display__FpFLc {
        margin: 0;
        max-width: 262px;
        font-family: "Unilever Desire", sans-serif;
        font-size: 14px;
        font-weight: 400;
        line-height: 16px;
        color: #333C43; }
      .LandingHeader_popupModal__rtaTq .LandingHeader_popup__yoe6\\+ .LandingHeader_dtAccess__ov8vb .LandingHeader_toggle__-mSwa {
        margin: 0;
        display: flex;
        align-items: center;
        color: #0066CC;
        font-family: "Unilever Desire", sans-serif;
        font-size: 14px;
        font-weight: 600;
        line-height: 16px;
        cursor: pointer; }
    .LandingHeader_popupModal__rtaTq .LandingHeader_popup__yoe6\\+ .LandingHeader_popupLogout__bqlcq {
      display: flex;
      flex-direction: row;
      align-items: center;
      width: 100%;
      padding: 0;
      cursor: pointer;
      background: transparent;
      border: 0; }
      .LandingHeader_popupModal__rtaTq .LandingHeader_popup__yoe6\\+ .LandingHeader_popupLogout__bqlcq:focus-visible {
        outline: 2px solid #0066CC;
        outline-offset: 3px;
        border-radius: 6px; }
      .LandingHeader_popupModal__rtaTq .LandingHeader_popup__yoe6\\+ .LandingHeader_popupLogout__bqlcq p {
        margin: 0;
        font-family: "Unilever Desire", sans-serif;
        font-size: 16px;
        font-weight: 600;
        line-height: 16px;
        color: #0066CC; }
    .LandingHeader_popupModal__rtaTq .LandingHeader_popup__yoe6\\+ .LandingHeader_display__FpFLc {
      margin: 0;
      font-family: "Unilever Desire", sans-serif;
      font-size: 14px;
      font-weight: 400;
      line-height: 16px;
      color: #030D14; }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    .LandingHeader_popupModal__rtaTq {
      display: none; } }

.LandingHeader_sideMenuOptions__iu59s {
  min-height: 64px;
  display: none; }
  @media (max-width: 848px) {
    .LandingHeader_sideMenuOptions__iu59s {
      display: flex;
      flex-direction: row;
      gap: 16px;
      align-items: center;
      width: 100%;
      cursor: pointer; }
      .LandingHeader_sideMenuOptions__iu59s p {
        font-size: 14px;
        font-weight: 400;
        color: #030D14;
        margin-bottom: 0; } }

.LandingHeader_menuSide__tWU81 {
  cursor: default; }
  @media (max-width: 848px) {
    .LandingHeader_menuSide__tWU81 {
      position: fixed;
      top: 68px;
      right: 0;
      left: auto;
      bottom: 0;
      height: calc(100vh - 68px);
      width: 86vw;
      max-width: 360px;
      background-color: #FFFFFF;
      color: #000000;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      z-index: 999;
      visibility: visible;
      overflow-y: auto;
      overflow-x: auto;
      max-height: calc(100vh - 68px);
      min-height: 0;
      overscroll-behavior: contain;
      -webkit-overflow-scrolling: touch;
      padding: 16px;
      margin-right: 0;
      border-radius: 16px 0 0 16px;
      box-shadow: -6px 0px 24px rgba(0, 0, 0, 0.14);
      top: 70px; } }

.LandingHeader_userName__Nc2\\+q {
  font-size: 20px !important;
  font-weight: 900 !important; }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    .LandingHeader_userName__Nc2\\+q {
      font-size: 16px !important; } }

.LandingHeader_username__FmzfW {
  margin-right: 180px;
  cursor: pointer; }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    .LandingHeader_username__FmzfW {
      margin-right: 0px;
      padding-bottom: 4px !important; } }
  .LandingHeader_username__FmzfW .LandingHeader_userName__Nc2\\+q {
    font-size: 20px !important;
    font-weight: 900 !important; }
    @media only screen and (min-width: 320px) and (max-width: 767px) {
      .LandingHeader_username__FmzfW .LandingHeader_userName__Nc2\\+q {
        font-size: 16px !important; } }

.LandingHeader_headerbottom__6MBUS, .LandingHeader_headerSidebar__O6\\+cf {
  width: 100%;
  height: 56px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #275CE6; }
  .LandingHeader_headerbottom__6MBUS p, .LandingHeader_headerSidebar__O6\\+cf p {
    margin-bottom: 0px !important;
    font-weight: 400;
    font-size: 14px;
    color: #FFFFFF; }
  .LandingHeader_headerbottom__6MBUS .LandingHeader_hamMenu__h3l2Z, .LandingHeader_headerSidebar__O6\\+cf .LandingHeader_hamMenu__h3l2Z {
    display: none; }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    .LandingHeader_headerbottom__6MBUS, .LandingHeader_headerSidebar__O6\\+cf {
      height: 60px;
      justify-content: flex-end; }
      .LandingHeader_headerbottom__6MBUS .LandingHeader_hamMenu__h3l2Z, .LandingHeader_headerSidebar__O6\\+cf .LandingHeader_hamMenu__h3l2Z {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 4px;
        margin-left: 18px;
        margin-right: auto; }
      .LandingHeader_headerbottom__6MBUS .LandingHeader_hamMenu__h3l2Z div, .LandingHeader_headerSidebar__O6\\+cf .LandingHeader_hamMenu__h3l2Z div {
        width: 20px;
        height: 2px;
        border-radius: 2px;
        background-color: #FFFFFF; }
      .LandingHeader_headerbottom__6MBUS p, .LandingHeader_headerSidebar__O6\\+cf p {
        margin-right: 16px;
        font-size: 16px;
        margin-bottom: 0 !important; } }

@media only screen and (min-width: 320px) and (max-width: 767px) {
  .LandingHeader_headerSidebar__O6\\+cf {
    position: fixed;
    background-color: #275CE6;
    display: flex;
    flex-direction: column;
    height: 170px;
    width: 100%;
    justify-content: space-around;
    z-index: 999; }
    .LandingHeader_headerSidebar__O6\\+cf div,
    .LandingHeader_headerSidebar__O6\\+cf p {
      width: 100%;
      display: flex; }
    .LandingHeader_headerSidebar__O6\\+cf .LandingHeader_hamMenu__h3l2Z {
      display: flex;
      justify-content: flex-end;
      align-items: flex-end;
      margin-left: 0;
      position: absolute;
      top: 22px;
      right: 22px; }
    .LandingHeader_headerSidebar__O6\\+cf p {
      font-size: 16px;
      position: absolute;
      bottom: 60px;
      left: 16px;
      width: auto; }
    .LandingHeader_headerSidebar__O6\\+cf .LandingHeader_countryNameMbl__I9kfJ {
      display: none; } }

.LandingHeader_menuIcons__qQpou {
  display: none; }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    .LandingHeader_menuIcons__qQpou {
      display: block; } }

@media (max-width: 848px) {
  .LandingHeader_menuSide__tWU81 {
    border-radius: 16px 0 0 16px;
    padding-top: 16px;
    position: fixed;
    height: calc(100vh - 68px);
    padding-left: 16px;
    overflow-y: auto;
    overflow-x: auto;
    max-height: calc(100vh - 68px);
    min-height: 0;
    overscroll-behavior: contain;
    -webkit-overflow-scrolling: touch;
    z-index: 2000;
    gap: 12px; } }

@media only screen and (min-width: 320px) and (max-width: 767px) {
  .LandingHeader_logout__wCX5w {
    display: none; } }

.LandingHeader_logout_blue__Gzipb {
  display: none; }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    .LandingHeader_logout_blue__Gzipb {
      display: block; } }

.LandingHeader_userHeaderMbl__ENplN {
  display: none; }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    .LandingHeader_userHeaderMbl__ENplN {
      display: block; } }

.LandingHeader_userHeaderDesktop__puXgz {
  display: block;
  margin-left: 180px;
  cursor: pointer; }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    .LandingHeader_userHeaderDesktop__puXgz {
      display: none; } }

.LandingHeader_headerbottom__6MBUS .LandingHeader_backButton__jpK3i p, .LandingHeader_headerSidebar__O6\\+cf .LandingHeader_backButton__jpK3i p {
  font-size: 16px; }

@media only screen and (min-width: 320px) and (max-width: 767px) {
  .LandingHeader_headerbottom__6MBUS .LandingHeader_backButton__jpK3i, .LandingHeader_headerSidebar__O6\\+cf .LandingHeader_backButton__jpK3i {
    display: none; } }

.LandingHeader_dropdownConatiner__2TZ8c {
  display: flex;
  gap: 16px;
  height: 100%;
  padding: 0px 8px;
  align-items: center;
  margin-left: 180px; }
  .LandingHeader_dropdownConatiner__2TZ8c .LandingHeader_dropdownWrapper__bapbM {
    display: flex;
    height: 100%; }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    .LandingHeader_dropdownConatiner__2TZ8c {
      flex-direction: column !important;
      display: none; } }
  .LandingHeader_dropdownConatiner__2TZ8c .LandingHeader_dropdownselected__L8W55 {
    background: #5588F7;
    border-bottom: 3px solid white; }
    .LandingHeader_dropdownConatiner__2TZ8c .LandingHeader_dropdownselected__L8W55 span {
      font-weight: 600; }
  .LandingHeader_dropdownConatiner__2TZ8c .LandingHeader_dropdown__XvCUm {
    position: relative;
    height: 100%;
    align-items: center;
    display: flex; }
    @media only screen and (min-width: 320px) and (max-width: 767px) {
      .LandingHeader_dropdownConatiner__2TZ8c .LandingHeader_dropdown__XvCUm {
        flex-direction: column !important; } }
    .LandingHeader_dropdownConatiner__2TZ8c .LandingHeader_dropdown__XvCUm span {
      color: white;
      font-size: 14px;
      padding: 0px 8px; }
      @media only screen and (min-width: 320px) and (max-width: 767px) {
        .LandingHeader_dropdownConatiner__2TZ8c .LandingHeader_dropdown__XvCUm span {
          color: black; } }
    .LandingHeader_dropdownConatiner__2TZ8c .LandingHeader_dropdown__XvCUm .LandingHeader_dropdownBody__UPKTt {
      position: absolute;
      z-index: 1;
      background: #275CE6;
      border-radius: 8px;
      padding: 1rem 0px;
      display: flex;
      width: 322px;
      flex-direction: column;
      align-items: flex-start;
      box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
      top: 90%;
      z-index: 9999; }
      .LandingHeader_dropdownConatiner__2TZ8c .LandingHeader_dropdown__XvCUm .LandingHeader_dropdownBody__UPKTt .LandingHeader_dropdownOptions__ceFP\\+:hover {
        background-color: #5588F7;
        font-weight: 600; }
      .LandingHeader_dropdownConatiner__2TZ8c .LandingHeader_dropdown__XvCUm .LandingHeader_dropdownBody__UPKTt .LandingHeader_dropdownOptions__ceFP\\+ {
        font-size: 14px;
        font-weight: 400;
        color: white;
        width: 100%;
        padding: 8px 1rem; }

.LandingHeader_SMOMobileView__Q\\+Nvb {
  min-height: 64px;
  background: transparent;
  border: 0;
  width: 100%;
  text-align: left; }
  .LandingHeader_SMOMobileView__Q\\+Nvb:focus-visible {
    outline: 2px solid #0066CC;
    outline-offset: 4px;
    border-radius: 6px; }

.LandingHeader_dropdownMobile__Evlmu {
  flex-direction: column !important;
  gap: 0px !important;
  height: max-content;
  justify-content: flex-start;
  font-size: 14px !important;
  align-items: flex-start !important;
  width: 100%; }
  .LandingHeader_dropdownMobile__Evlmu .LandingHeader_dropdownHeading__5Uhe6 {
    margin-left: 0px;
    min-height: 64px;
    display: flex;
    justify-content: space-between;
    width: 100%; }
    .LandingHeader_dropdownMobile__Evlmu .LandingHeader_dropdownHeading__5Uhe6 .LandingHeader_dropdownHeadingName__BuYZY {
      flex-basis: 75%; }
    .LandingHeader_dropdownMobile__Evlmu .LandingHeader_dropdownHeading__5Uhe6 .LandingHeader_dropdownHeadingArrow__xlVSk {
      flex-basis: 25%;
      justify-content: center; }
  .LandingHeader_dropdownMobile__Evlmu .LandingHeader_dropdownArrowOpen__yKeps {
    transform: rotate(-90deg); }
  .LandingHeader_dropdownMobile__Evlmu .LandingHeader_dropdownArrowClose__SYk5X {
    transform: rotate(90deg); }
  .LandingHeader_dropdownMobile__Evlmu span {
    width: 100%; }
  .LandingHeader_dropdownMobile__Evlmu .LandingHeader_dropdownBody__UPKTt {
    flex-direction: column !important;
    gap: 0px !important;
    overflow: scroll;
    width: calc(100% + 16px);
    margin-left: -16px !important; }
    .LandingHeader_dropdownMobile__Evlmu .LandingHeader_dropdownBody__UPKTt .LandingHeader_dropdownOptions__ceFP\\+ {
      margin: 0px !important;
      width: 100%;
      padding-left: calc(2.5rem + 16px);
      min-height: 48px; }
      .LandingHeader_dropdownMobile__Evlmu .LandingHeader_dropdownBody__UPKTt .LandingHeader_dropdownOptions__ceFP\\+ div {
        min-height: 48px; }
    .LandingHeader_dropdownMobile__Evlmu .LandingHeader_dropdownBody__UPKTt .LandingHeader_dropdownSelected__qgxoH {
      background: #F3F7FD; }

.LandingHeader_navLinkSelected__UWqIc {
  height: 100%;
  padding: 0px 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-weight: 600;
  background-color: #5588F7 !important;
  position: relative; }

.LandingHeader_navLinkSelected__UWqIc::after {
  content: "";
  border: 3px solid #F3F7FD;
  position: absolute;
  bottom: -2px;
  width: 102%;
  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.1); }

.LandingHeader_adminDropdown__B11SS {
  position: relative; }
  .LandingHeader_adminDropdown__B11SS img:last-child {
    position: absolute;
    right: 16px;
    transform: rotate(90deg);
    transition: transform 0.1s ease-in-out; }
  .LandingHeader_adminDropdown__B11SS .LandingHeader_invertArrow__o-YrC {
    transform: rotate(-90deg) !important; }

.LandingHeader_adminDropdownOptions__xuOBS {
  display: flex;
  flex-direction: column !important;
  justify-content: center;
  align-items: flex-start !important;
  padding-left: 38px; }
  .LandingHeader_adminDropdownOptions__xuOBS p {
    height: 40px;
    display: flex;
    align-items: center; }

.LandingHeader_dropdownCountry__G98p8 {
  width: auto;
  min-width: fit-content;
  max-width: fit-content;
  flex-shrink: 0; }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    .LandingHeader_dropdownCountry__G98p8 {
      width: 60px; } }
  @media (max-width: 848px) {
    .LandingHeader_dropdownCountry__G98p8 {
      min-width: 210px;
      max-width: 260px; } }
  .LandingHeader_dropdownCountry__G98p8 .LandingHeader_dropdownControl__8T-SU {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: nowrap;
    gap: 0px;
    height: 100%;
    padding: 0px;
    background-color: #FFFFFF;
    border: none;
    outline: none;
    width: auto;
    overflow: visible;
    cursor: pointer; }
    .LandingHeader_dropdownCountry__G98p8 .LandingHeader_dropdownControl__8T-SU:hover {
      border: none;
      box-shadow: none;
      outline: none; }
    .LandingHeader_dropdownCountry__G98p8 .LandingHeader_dropdownControl__8T-SU:focus-visible {
      outline: 2px solid #0066CC;
      outline-offset: 2px;
      border-radius: 6px; }
    @media (max-width: 848px) {
      .LandingHeader_dropdownCountry__G98p8 .LandingHeader_dropdownControl__8T-SU {
        min-height: 40px; } }
    .LandingHeader_dropdownCountry__G98p8 .LandingHeader_dropdownControl__8T-SU .LandingHeader_countryName__8zo6U {
      border-right: 0;
      padding: 0 4px 0 4px;
      flex-wrap: nowrap; }
      .LandingHeader_dropdownCountry__G98p8 .LandingHeader_dropdownControl__8T-SU .LandingHeader_countryName__8zo6U .LandingHeader_nameOption__OCLv2 {
        font-size: 20px;
        font-weight: 400;
        color: #030D14;
        margin: 0;
        line-height: 1.2;
        white-space: nowrap; }
    .LandingHeader_dropdownCountry__G98p8 .LandingHeader_dropdownControl__8T-SU .LandingHeader_dropdownArrow__jBYvj div {
      padding: 0;
      color: #0066CC;
      display: flex;
      align-items: center; }
    .LandingHeader_dropdownCountry__G98p8 .LandingHeader_dropdownControl__8T-SU .LandingHeader_dropdownArrow__jBYvj div::after {
      content: "";
      width: 20px;
      height: 20px;
      display: block;
      background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) center/contain no-repeat; }
    .LandingHeader_dropdownCountry__G98p8 .LandingHeader_dropdownControl__8T-SU .LandingHeader_dropdownArrow__jBYvj svg {
      display: none !important; }
    .LandingHeader_dropdownCountry__G98p8 .LandingHeader_dropdownControl__8T-SU .LandingHeader_dropdownText__jiaCR {
      width: 100%;
      max-width: 100%;
      min-width: 0;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 20px;
      font-weight: 400;
      color: #030D14;
      font-family: "Unilever Desire", sans-serif; }
  .LandingHeader_dropdownCountry__G98p8 .LandingHeader_seperator__EfkFC {
    display: none; }
  .LandingHeader_dropdownCountry__G98p8 .LandingHeader_menu__kf0Us {
    width: fit-content;
    overflow: visible;
    border-radius: 5px;
    z-index: 99999; }
    @media only screen and (min-width: 320px) and (max-width: 767px) {
      .LandingHeader_dropdownCountry__G98p8 .LandingHeader_menu__kf0Us {
        position: absolute;
        right: 15%; } }
    @media (max-width: 848px) {
      .LandingHeader_dropdownCountry__G98p8 .LandingHeader_menu__kf0Us {
        position: absolute;
        right: 0;
        z-index: 99999; } }
  .LandingHeader_dropdownCountry__G98p8 .LandingHeader_menuList__-jF0A {
    padding: 0;
    border-radius: 5px; }
  .LandingHeader_dropdownCountry__G98p8 .LandingHeader_menuOption__gvQFM {
    min-width: 100%;
    background-color: #FFFFFF;
    width: fit-content;
    padding: 4px 8px;
    cursor: pointer;
    border-bottom: none; }
    .LandingHeader_dropdownCountry__G98p8 .LandingHeader_menuOption__gvQFM .LandingHeader_countryName__8zo6U {
      border-right: 0;
      padding: 0 4px;
      flex-wrap: nowrap; }
      .LandingHeader_dropdownCountry__G98p8 .LandingHeader_menuOption__gvQFM .LandingHeader_countryName__8zo6U .LandingHeader_nameOption__OCLv2 {
        font-size: 16px;
        font-weight: 400;
        margin: 0;
        line-height: 1.2;
        color: #000000;
        white-space: nowrap; }
    .LandingHeader_dropdownCountry__G98p8 .LandingHeader_menuOption__gvQFM:hover {
      background-color: #F3F7FD; }
    .LandingHeader_dropdownCountry__G98p8 .LandingHeader_menuOption__gvQFM .LandingHeader_selected__k7y7O {
      background-color: #F3F7FD; }

.LandingHeader_dropdownArrowHidden__BgXTz {
  display: none !important; }
`, "",{"version":3,"sources":["webpack://./src/assets/styles/_mixin.scss","webpack://./src/components/LandingHomePage/LandingHeader/LandingHeader.module.scss","webpack://./src/assets/styles/_variables.scss"],"names":[],"mappings":"AAIA;EACE,8BAA8B;EAC9B,+DAAkE;EAClE,mBAAmB;EACnB,kBAAkB,EAAA;;ACLpB;EACE,eAAe;EACf,aAAa;EACb,WAAW;EACX,QAAQ;EACR,iBAAiB,EAAA;;AAGnB;EACE,oBAAoB,EAAA;;AAGtB;EACE,WAAW;EACX,yBCZY;EDaZ,gCAAgC;EAChC,+EAA+E,EAAA;;AAGjF;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ,EAAA;EAHV;IDRE,0CAA0C;ICcxC,0BAA6C;IAC7C,2BAA2C;IAC3C,cAAc;IACd,0BAA0B,EAAA;EDT5B;ICAF;MAaI,iBAAiB,EAAA,EAQpB;EArBD;IAiBI,kBAAkB;IAClB,aAAa;IACb,cAAc,EAAA;;AAIlB;EACE,+BC1CmB;ED2CnB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,QAAQ;EACR,mBCce,EAAA;EDpBjB;IAQI,0BAA0C;IAC1C,2BAA2C;IAC3C,6BAA6B,EAAA;EDjC/B;ICuBF;MAcI,iBAAiB,EAAA,EAOpB;EArBD;IAmBI,kBAAkB,EAAA;;AAItB;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB,EAAA;EACnB;IAPF;MAQI,mBAAmB;MACnB,YAAY,EAAA,EAEf;;AAED;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,aAAa,EAAA;EAXf;IAcI,WAAW;IACX,YAAY;IACZ,mBAAmB,EAAA;EAGrB;IAnBF;MAoBI,aAAa,EAAA,EAEhB;;AACD;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SC9Ce;ED+Cf,iBAAiB;EACjB,eAAe;EACf,uBAAuB;EACvB,SAAS;EACT,UAAU,EAAA;EATZ;IAYI,0BAA0B;IAC1B,mBAAmB;IACnB,kBAAkB,EAAA;EAdtB;IAkBI,WAAW;IACX,YAAY,EAAA;EAGd;IAtBF;MAuBI,aAAa;MACb,iBAAiB,EAAA,EAEpB;;AAED;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,cAAc,EAAA;;AAGhB;EACE,WAAW;EACX,YAAY,EAAA;;AAGd;EACE,eAAe,EAAA;EAEf;IAHF;MAII,cAAc;MACd,YAAY;MACZ,WAAW,EAAA,EAEd;;AACD;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,eAAe,EAAA;EAPjB;IASI,eCjIoB;IDkIpB,gBCvHoB;IDwHpB,kBC5Gc;ID6Gd,cAAc,EAAA;EAZlB;IAeI,aAAa;IACb,QAAQ;IACR,mBAAmB;IACnB,eAAe,EAAA;IAlBnB;MAoBM,gBCjIkB;MDkIlB,eC7IkB,EAAA;EDgJtB;IAxBF;MAyBI,kBAAkB;MAClB,WAAW;MACX,kBAAkB,EAAA,EAErB;;AACD;EACE,yBAAyB;EACzB,UCjIgB;EDkIhB,eAAe;EACf,8BCjLkB;EDkLlB,cAAc,EAAA;EACd;IANF;MAOI,wBAAwB,EAAA,EAE3B;;AAED;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,UAAU,EAAA;EAPZ;IAUI,0BAA0B;IAC1B,mBAAmB;IACnB,kBAAkB,EAAA;ED7LpB;ICiLF;MAgBI,aAAa,EAAA,EAMhB;EAHC;IAnBF;MAoBI,aAAa,EAAA,EAEhB;;AAGC;EADF;IAEI,wBAAwB;IACxB,iBAAiB,EAAA,EAEpB;;AAED;EACE,aAAa,EAAA;EACb;IAFF;MAGI,aAAa;MACb,sBAAsB;MACtB,WAAW;MACX,eAAe;MACf,gBAAgB;MAChB,mBCzOU;MD0OV,yBAAyB;MACzB,mBAAmB;MACnB,8CAA8C;MAC9C,gBAAgB;MAChB,kBAAkB;MAClB,iCAAiC,EAAA,EAEpC;;AAED;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBChPsB,EAAA;;ADmPxB;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB,EAAA;;AAGrB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY,EAAA;EAJd;IAOI,SAAS;ID/PX,0CAA0C;ICiQxC,eCxOsB;IDyOtB,gBAAgB;IAChB,iBAAiB;IACjB,cAAc,EAAA;EAZlB;IAgBI,SAAS;IDxQX,0CAA0C;IC0QxC,eClPoB;IDmPpB,gBCxOoB;IDyOpB,iBAAiB;IACjB,cCxQiB;IDyQjB,gBAAgB;IAChB,uBAAuB,EAAA;;AAI3B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,oBAAoB,EAAA;;AAGtB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ,EAAA;;AAGV;EACE,SAAS;EDnST,0CAA0C;ECqS1C,eC7QsB;ED8QtB,gBAAgB;EAChB,iBAAiB;EACjB,cCnSmB,EAAA;;ADsSrB;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB,EAAA;;AAGrB;EACE,SAAS;EDnTT,0CAA0C;ECqT1C,eC7RsB;ED8RtB,gBCnRsB;EDoRtB,iBAAiB;EACjB,cAAc,EAAA;;AAGhB;EACE,SAAS;ED5TT,0CAA0C;EC8T1C,eCtSsB;EDuStB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,eAAe,EAAA;;AAGjB;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,SAAS;EACT,UAAU,EAAA;EANZ;IASI,0BAA0B;IAC1B,mBAAmB;IACnB,kBAAkB,EAAA;EAXtB;IAeI,SAAS;IDpVX,0CAA0C;ICsVxC,eC7TsB;ID8TtB,gBAAgB;IAChB,iBAAiB;IACjB,cAAc,EAAA;;AAIlB;EACE,iBAAiB,EAAA;EDtVjB;ICqVF;MAGI,wBAAwB,EAAA,EAE3B;;AACD;EACE,0BAAa,EAAA;;AAEf;EACE,oCAAmC;EACnC,6BAA6B;EAC7B,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,4CAA4C;EAC5C,UAAU,EAAA;EARZ;IAUI,qBAAqB;IACrB,kBAAkB,EAAA;EAXtB;IAcI,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,sBAAsB;IACtB,uBAAuB,EAAA;IApB3B;MAsBM,aAAa;MACb,mBAAmB;MACnB,mBAAmB;MACnB,SAAS;MACT,aAAa;MACb,WAAW;MACX,eAAe;MACf,sBAAsB;MACtB,mBAAmB;MACnB,yBCtYkB,EAAA;IDuWxB;MAkCM,cAAc;MACd,eAAe;MACf,cAAc;MACd,mBAAmB,EAAA;IArCzB;MAwCM,aAAa;MACb,sBAAsB;MACtB,QAAQ,EAAA;MA1Cd;QA4CQ,SAAS;QDlZf,0CAA0C;QCoZpC,eC3XkB;QD4XlB,gBAAgB;QAChB,iBAAiB;QACjB,cAAc,EAAA;MAjDtB;QAoDQ,SAAS;QD1Zf,0CAA0C;QC4ZpC,eCpYgB;QDqYhB,gBC1XgB;QD2XhB,iBAAiB;QACjB,cAAc,EAAA;IAzDtB;MA6DM,aAAa;MACb,sBAAsB;MACtB,uBAAuB;MACvB,SAAS;MACT,WAAW;MACX,kBAAkB;MAClB,sBAAsB,EAAA;IAnE5B;MAsEM,aAAa;MACb,sBAAsB;MACtB,uBAAuB;MACvB,QAAQ;MACR,WAAW,EAAA;IA1EjB;MA6EM,SAAS;MDnbb,0CAA0C;MCqbtC,eC5ZoB;MD6ZpB,gBAAgB;MAChB,iBAAiB;MACjB,cCnbe,EAAA;IDiWrB;MAqFM,aAAa;MACb,mBAAmB;MACnB,QAAQ;MACR,mBAAmB;MACnB,WAAW;MACX,cC3be,EAAA;MDiWrB;QA4FQ,SAAS;QACT,gBAAgB;QDnctB,0CAA0C;QCqcpC,eC7agB;QD8ahB,gBCnagB;QDoahB,iBAAiB;QACjB,cCnca,EAAA;MDiWrB;QAqGQ,SAAS;QACT,aAAa;QACb,mBAAmB;QACnB,cAAc;QD9cpB,0CAA0C;QCgdpC,eCxbgB;QDybhB,gBAAgB;QAChB,iBAAiB;QACjB,eAAe,EAAA;IA7GvB;MAiHM,aAAa;MACb,mBAAmB;MACnB,mBAAmB;MACnB,WAAW;MACX,UAAU;MACV,eAAe;MACf,uBAAuB;MACvB,SAAS,EAAA;MAxHf;QA2HQ,0BAA0B;QAC1B,mBAAmB;QACnB,kBAAkB,EAAA;MA7H1B;QAiIQ,SAAS;QDvef,0CAA0C;QCyepC,eChdkB;QDidlB,gBAAgB;QAChB,iBAAiB;QACjB,cAAc,EAAA;IAtItB;MA0IM,SAAS;MDhfb,0CAA0C;MCkftC,eC1dkB;MD2dlB,gBChdkB;MDidlB,iBAAiB;MACjB,cAAc,EAAA;ED7elB;IC8VF;MAmJI,aAAa,EAAA,EAEhB;;AACD;EACE,gBAAgB;EAChB,aAAa,EAAA;EACb;IAHF;MAII,aAAa;MACb,mBAAmB;MACnB,SAAS;MACT,mBAAmB;MACnB,WAAW;MACX,eAAe,EAAA;MATnB;QAWM,eC/ekB;QDgflB,gBCrekB;QDselB,cAAc;QACd,gBAAgB,EAAA,EACjB;;AAIL;EAEE,eAAe,EAAA;EACf;IAHF;MAII,eAAe;MACf,SAAS;MACT,QAAQ;MACR,UAAU;MACV,SAAS;MACT,0BAA0B;MAC1B,WAAW;MACX,gBAAgB;MAChB,yBCpiBU;MDqiBV,cC9hBU;MD+hBV,aAAa;MACb,sBAAsB;MACtB,uBAAuB;MACvB,YAAY;MACZ,mBAAmB;MACnB,gBAAgB;MAChB,gBAAgB;MAChB,8BAA8B;MAC9B,aAAa;MACb,4BAA4B;MAC5B,iCAAiC;MACjC,aAAa;MACb,eAAe;MACf,4BAA4B;MAC5B,6CAA6C;MAC7C,SAAS,EAAA,EAEZ;;AACD;EACE,0BAA0B;EAC1B,2BAA2B,EAAA;EDziB3B;ICuiBF;MAII,0BAA0B,EAAA,EAE7B;;AACD;EACE,mBAAmB;EACnB,eAAe,EAAA;EDhjBf;IC8iBF;MAKI,iBAAiB;MACjB,8BAA8B,EAAA,EAUjC;EAhBD;IAUI,0BAA0B;IAC1B,2BAA2B,EAAA;IDzjB7B;MC8iBF;QAaM,0BAA0B,EAAA,EAE7B;;AAEH;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,8BAA8B;EAE9B,mBAAmB;EACnB,yBCzlBkB,EAAA;EDklBpB;IASI,6BAA6B;IAC7B,gBC9iBoB;ID+iBpB,eC1jBoB;ID2jBpB,cC5lBU,EAAA;EDglBd;IAeI,aAAa,EAAA;ED9kBf;IC+jBF;MAkBI,YAAY;MACZ,yBAAyB,EAAA;MAnB7B;QAqBM,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,mBAAmB;QACnB,QAAQ;QACR,iBAAiB;QACjB,kBAAkB,EAAA;MA3BxB;QA8BM,WAAW;QACX,WAAW;QACX,kBAAkB;QAClB,yBCjnBQ,EAAA;MDglBd;QAoCM,kBAAkB;QAClB,eCnlBoB;QDolBpB,2BAA2B,EAAA,EAC5B;;ADtmBH;ECymBF;IAGI,eAAe;IACf,yBChoBgB;IDioBhB,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,WAAW;IACX,6BAA6B;IAC7B,YAAY,EAAA;IAVhB;;MAaM,WAAW;MACX,aAAa,EAAA;IAdnB;MAiBM,aAAa;MACb,yBAAyB;MACzB,qBAAqB;MACrB,cAAc;MACd,kBAAkB;MAClB,SAAS;MACT,WAAW,EAAA;IAvBjB;MA0BM,eClnBoB;MDmnBpB,kBAAkB;MAClB,YAAY;MACZ,UAAU;MACV,WAAW,EAAA;IA9BjB;MAiCM,aAAa,EAAA,EACd;;AAGL;EACE,aAAa,EAAA;ED/oBb;IC8oBF;MAGI,cAAc,EAAA,EAEjB;;AAEC;EA9IF;IA+II,4BAA4B;IAC5B,iBAAiB;IACjB,eAAe;IACf,0BAA0B;IAC1B,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,8BAA8B;IAC9B,aAAa;IACb,4BAA4B;IAC5B,iCAAiC;IACjC,aAAa;IACb,SAAS,EAAA,EAEZ;;ADpqBC;ECqqBF;IAEI,aAAa,EAAA,EAEhB;;AACD;EACE,aAAa,EAAA;ED3qBb;IC0qBF;MAGI,cAAc,EAAA,EAEjB;;AAED;EACE,aAAa,EAAA;EDlrBb;ICirBF;MAII,cAAc,EAAA,EAEjB;;AAED;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe,EAAA;ED5rBf;ICyrBF;MAMI,aAAa,EAAA,EAEhB;;AAED;EAGM,eAAe,EAAA;;ADtsBnB;ECmsBF;IAOM,aAAa,EAAA,EAEhB;;AAOH;EACE,aAAa;EACb,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB,EAAA;EANpB;IASI,aAAa;IACb,YAAY,EAAA;ED7tBd;ICmtBF;MAcI,iCAAiC;MACjC,aAAa,EAAA,EAyDhB;EAxED;IAmBI,mBCxvBiB;IDyvBjB,8BAA8B,EAAA;IApBlC;MAsBM,gBAAgB,EAAA;EAtBtB;IA2BI,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,aAAa,EAAA;IDjvBf;MCmtBF;QAiCM,iCAAiC,EAAA,EAsCpC;IAvEH;MAqCM,YAAY;MACZ,eAAe;MACf,gBAAgB,EAAA;MD1vBpB;QCmtBF;UA0CQ,YAAY,EAAA,EAEf;IA5CL;MA8CM,kBAAkB;MAClB,UAAU;MACV,mBCtxBc;MDuxBd,kBAAkB;MAClB,iBAAiB;MACjB,aAAa;MACb,YAAY;MACZ,sBAAsB;MACtB,uBAAuB;MACvB,2CAA2C;MAC3C,QAAQ;MACR,aAAa,EAAA;MAzDnB;QA4DQ,yBCjyBa;QDkyBb,gBAAgB,EAAA;MA7DxB;QAgEQ,eAAe;QACf,gBAAgB;QAChB,YAAY;QACZ,WAAW;QACX,iBAAiB,EAAA;;AAMzB;EACE,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,gBAAgB,EAAA;EALlB;IAQI,0BAA0B;IAC1B,mBAAmB;IACnB,kBAAkB,EAAA;;AAItB;EACE,iCAAiC;EACjC,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,0BAA0B;EAC1B,kCAAkC;EAClC,WAAW,EAAA;EAPb;IAUI,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,8BAA8B;IAC9B,WAAW,EAAA;IAdf;MAgBM,eAAe,EAAA;IAhBrB;MAmBM,eAAe;MACf,uBAAuB,EAAA;EApB7B;IAyBI,yBAAyB,EAAA;EAzB7B;IA6BI,wBAAwB,EAAA;EA7B5B;IAiCI,WAAW,EAAA;EAjCf;IAqCI,iCAAiC;IACjC,mBAAmB;IACnB,gBAAgB;IAChB,wBAAwB;IACxB,6BAA6B,EAAA;IAzCjC;MA4CM,sBAAsB;MACtB,WAAW;MACX,iCAAiC;MACjC,gBAAgB,EAAA;MA/CtB;QAiDQ,gBAAgB,EAAA;IAjDxB;MAqDM,mBCz2BkB,EAAA;;AD62BxB;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAGhB,oCAA0C;EAC1C,kBAAkB,EAAA;;AAEpB;EACE,WAAW;EACX,yBC53BsB;ED63BtB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,8CAA8C,EAAA;;AAEhD;EACE,kBAAkB,EAAA;EADpB;IAGI,kBAAkB;IAClB,WAAW;IACX,wBAAwB;IACxB,sCAAsC,EAAA;EAN1C;IASI,oCAAoC,EAAA;;AAGxC;EACE,aAAa;EACb,iCAAiC;EACjC,uBAAuB;EACvB,kCAAkC;EAClC,kBAAkB,EAAA;EALpB;IAQI,YAAY;IACZ,aAAa;IACb,mBAAmB,EAAA;;AAIvB;EACE,WAAW;EACX,sBAAsB;EACtB,sBAAsB;EACtB,cAAc,EAAA;EDv5Bd;ICm5BF;MAMI,WAAW,EAAA,EAuId;EArIC;IARF;MASI,gBAAgB;MAChB,gBAAgB,EAAA,EAmInB;EA7ID;IAcI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,iBAAiB;IACjB,QAAQ;IACR,YAAY;IACZ,YCh4Bc;IDi4Bd,yBCz7BU;ID07BV,YAAY;IACZ,aAAa;IACb,WAAW;IACX,iBAAiB;IACjB,eAAe,EAAA;IA1BnB;MA4BM,YAAY;MACZ,gBAAgB;MAChB,aAAa,EAAA;IA9BnB;MAkCM,0BAA0B;MAC1B,mBAAmB;MACnB,kBAAkB,EAAA;IAEpB;MAtCJ;QAuCM,gBAAgB,EAAA,EA+CnB;IAtFH;MA0CM,eAAe;MACf,oBAAoB;MACpB,iBAAiB,EAAA;MA5CvB;QA8CQ,eC96BqB;QD+6BrB,gBCv6BgB;QDw6BhB,cAAc;QACd,SAAS;QACT,gBAAgB;QAChB,mBAAmB,EAAA;IAnD3B;MAyDQ,UAAU;MACV,cAAc;MACd,aAAa;MACb,mBAAmB,EAAA;IA5D3B;MA+DQ,WAAW;MACX,WAAW;MACX,YAAY;MACZ,cAAc;MACd,4EAAoF,EAAA;IAnE5F;MAsEQ,wBAAwB,EAAA;IAtEhC;MA2EM,WAAW;MACX,eAAe;MACf,YAAY;MACZ,mBAAmB;MACnB,gBAAgB;MAChB,uBAAuB;MACvB,eCj9BuB;MDk9BvB,gBC18BkB;MD28BlB,cAAc;MD9+BlB,0CAA0C,EAAA;EC25B5C;IAyFI,aAAa,EAAA;EAzFjB;IA6FI,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,cAAc,EAAA;IDn/BhB;MCm5BF;QAkGM,kBAAkB;QAClB,UAAU,EAAA,EAOb;IALC;MArGJ;QAsGM,kBAAkB;QAClB,QAAQ;QACR,cAAc,EAAA,EAEjB;EA1GH;IA6GI,UAAU;IACV,kBAAkB,EAAA;EA9GtB;IAkHI,eAAe;IACf,yBCvhCU;IDwhCV,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,mBAAmB,EAAA;IAvHvB;MAyHM,eAAe;MACf,cAAc;MACd,iBAAiB,EAAA;MA3HvB;QA6HQ,eC//BkB;QDggClB,gBCt/BgB;QDu/BhB,SAAS;QACT,gBAAgB;QAChB,cC9hCM;QD+hCN,mBAAmB,EAAA;IAlI3B;MAuIM,yBCniCkB,EAAA;ID45BxB;MA0IM,yBCtiCkB,EAAA;;AD2iCxB;EACE,wBAAwB,EAAA","sourcesContent":["﻿@import \"./variables\";\n\n// Font family\n\n@font-face {\n  font-family: \"Unilever Desire\";\n  src: url(\"../fonts/UnileverDesire-Regular.ttf\") format(\"truetype\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n// Font families and font-weights\n\n@mixin volteMedium {\n  font-family: \"Unilever Desire\", sans-serif;\n}\n\n@mixin volteSemibold {\n  font-family: \"Unilever Desire\", sans-serif;\n}\n\n@mixin sm {\n  @media only screen and (min-width: 320px) and (max-width: 767px) {\n    @content;\n  }\n}\n\n@mixin md {\n  @media only screen and (min-width: 768px) {\n    @content;\n  }\n}\n\n@mixin sm-min {\n  @media only screen and (min-width: 992px) {\n    @content;\n  }\n}\n\n@mixin lg {\n  @media only screen and (min-width: 1024px) {\n    @content;\n  }\n}\n\n@mixin xl-min {\n  @media only screen and (min-width: 1200px) {\n    @content;\n  }\n}\n\n@mixin xl {\n  @media only screen and (min-width: 1280px) {\n    @content;\n  }\n}\n\n@mixin xxl {\n  @media only screen and (min-width: 1440px) {\n    @content;\n  }\n}\n\n@mixin sm-tab {\n  @media only screen and (max-width: 767px) {\n    @content;\n  }\n}\n\n@mixin ipad {\n  @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {\n    @content;\n  }\n}\n\n\n","@import \"../../../assets/styles/variables\";\n@import \"../../../assets/styles/mixin\";\n\n.mainHeader {\n  position: fixed;\n  z-index: 9999;\n  width: 100%;\n  top: 0px;\n  display: contents;\n}\n\n.mainHeaderPassive {\n  pointer-events: none;\n}\n\n.header {\n  width: 100%;\n  background-color: $white;\n  border-bottom: 1px solid #E2E8F0;\n  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1), 0px 1px 2px -1px rgba(0, 0, 0, 0.1);\n}\n\n.countryName {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  .name {\n    @include volteMedium;\n    font-size: $font-size-md-xtraLarge !important;\n    font-weight: $font-weight-normal !important;\n    color: #030D14;\n    margin-top: 3px !important;\n  }\n\n  @include sm {\n    border-right: 0px;\n  }\n\n  .countryLogo {\n    border-radius: 50%;\n    width: 22.4px;\n    height: 22.4px;\n  }\n}\n\n.countryNameMbl {\n  border-right: 1px solid $secondryBlue;\n  display: flex;\n  align-items: center;\n  justify-self: end;\n  gap: 8px;\n  padding-right: $spacing-md;\n  .name {\n    font-size: $font-size-md-medium !important;\n    font-weight: $font-weight-normal !important;\n    margin-bottom: 5px !important;\n  }\n\n  @include sm {\n    border-right: 0px;\n  }\n\n  .countryLogo {\n    // border: 1px solid white;\n    border-radius: 50%;\n  }\n}\n\n.headertop {\n  height: 68px;\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  @media (max-width: 1199px) {\n    border-bottom: none;\n    height: 68px;\n  }\n}\n\n.hamburgerBtn {\n  display: none;\n  cursor: pointer;\n  background: none;\n  border: none;\n  padding: 8px;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  margin-left: auto;\n  margin-right: 16px;\n  z-index: 2100;\n\n  img {\n    width: 24px;\n    height: 24px;\n    background: #0066CC;\n  }\n\n  @media (max-width: 848px) {\n    display: flex;\n  }\n}\n.dttReports {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: $spacing-xs;\n  margin-left: 72px;\n  cursor: pointer;\n  background: transparent;\n  border: 0;\n  padding: 0;\n\n  &:focus-visible {\n    outline: 2px solid #0066CC;\n    outline-offset: 4px;\n    border-radius: 8px;\n  }\n\n  .backArrow {\n    width: 24px;\n    height: 24px;\n  }\n\n  @media (max-width: 848px) {\n    display: flex;\n    margin-left: 16px;\n  }\n}\n\n.logoIconContainer {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  width: 40px;\n  height: 40px;\n  background: #0066CC;\n  border-radius: 14px;\n  flex-shrink: 0;\n}\n\n.logoIcon {\n  width: 24px;\n  height: 24px;\n}\n\n.logoText {\n  height: 51.57px;\n\n  @media (max-width: 848px) {\n    display: block;\n    height: 28px;\n    width: auto;\n  }\n}\n.navlinks {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  color: #030D14;\n  margin-right: 72px;\n  gap: 23px;\n  cursor: default;\n  p {\n    font-size: $font-size-sm-base;\n    font-weight: $font-weight-normal;\n    margin-bottom: $spacing-zero;\n    color: #030D14;\n  }\n  span {\n    display: none;\n    gap: 8px;\n    align-items: center;\n    cursor: pointer;\n    p {\n      font-weight: $font-weight-normal;\n      font-size: $font-size-sm-base;\n    }\n  }\n  @media (max-width: 848px) {\n    position: absolute;\n    left: -200%;\n    visibility: hidden;\n  }\n}\n.headerDivider {\n  display: block !important;\n  width: $spacing-zero;\n  height: 34.76px;\n  border-left: 1px solid $inputBorder;\n  flex-shrink: 0;\n  @media (max-width: 848px) {\n    display: none !important;\n  }\n}\n\n.profileAvatar {\n  cursor: pointer;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  background: transparent;\n  border: 0;\n  padding: 0;\n\n  &:focus-visible {\n    outline: 2px solid #0066CC;\n    outline-offset: 4px;\n    border-radius: 8px;\n  }\n\n  @include sm {\n    display: none;\n  }\n\n  @media (max-width: 848px) {\n    display: none;\n  }\n}\n\n.profileAvatarInMenu {\n  @media (max-width: 848px) {\n    display: flex !important;\n    margin-left: auto;\n  }\n}\n\n.inlineProfilePanel {\n  display: none;\n  @media (max-width: 848px) {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    max-width: 100%;\n    margin-top: 12px;\n    background: $white;\n    border: 1px solid #E2E8F0;\n    border-radius: 12px;\n    box-shadow: 0px 4px 14px rgba(3, 13, 20, 0.08);\n    overflow-y: auto;\n    overflow-x: hidden;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n\n.inlineProfileHeader {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 14px 16px;\n  background: $timedetailsGrey;\n}\n\n.inlineProfileIcon {\n  width: 36px;\n  height: 36px;\n  object-fit: contain;\n}\n\n.inlineProfileInfo {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n\n  h4 {\n    margin: 0;\n    @include volteMedium;\n    font-size: $font-size-md-medium;\n    font-weight: 700;\n    line-height: 16px;\n    color: #030D14;\n  }\n\n  p {\n    margin: 0;\n    @include volteMedium;\n    font-size: $font-size-sm-base;\n    font-weight: $font-weight-normal;\n    line-height: 16px;\n    color: $darkGreyText;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n}\n\n.inlineProfileBody {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  padding: 16px;\n  min-width: 280px;\n  padding-bottom: 24px;\n}\n\n.inlineInfoBlock {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.inlineTitle {\n  margin: 0;\n  @include volteMedium;\n  font-size: $font-size-sm-base;\n  font-weight: 600;\n  line-height: 16px;\n  color: $darkGreyText;\n}\n\n.inlineDtAccess {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  align-items: center;\n}\n\n.inlineDisplay {\n  margin: 0;\n  @include volteMedium;\n  font-size: $font-size-sm-base;\n  font-weight: $font-weight-normal;\n  line-height: 16px;\n  color: #030D14;\n}\n\n.inlineToggle {\n  margin: 0;\n  @include volteMedium;\n  font-size: $font-size-sm-base;\n  font-weight: 600;\n  line-height: 16px;\n  color: #0066CC;\n  cursor: pointer;\n}\n\n.inlineLogout {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  background: transparent;\n  border: 0;\n  padding: 0;\n\n  &:focus-visible {\n    outline: 2px solid #0066CC;\n    outline-offset: 4px;\n    border-radius: 6px;\n  }\n\n  p {\n    margin: 0;\n    @include volteMedium;\n    font-size: $font-size-md-medium;\n    font-weight: 600;\n    line-height: 16px;\n    color: #0066CC;\n  }\n}\n\n.profileIcon {\n  margin-left: 20px;\n  @include sm {\n    display: none !important;\n  }\n}\n:root {\n  --rt-opacity: 1 !important;\n}\n.popupModal {\n  background-color: $white !important;\n  border-radius: 8px !important;\n  padding: 0 !important;\n  width: 294px;\n  overflow: hidden;\n  box-sizing: border-box;\n  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.16);\n  z-index: 4;\n  :global(.styles-module_content__ydYdI) {\n    padding: 0 !important;\n    border-radius: 8px;\n  }\n  .popup {\n    width: 294px;\n    max-width: 294px;\n    min-height: auto;\n    display: flex;\n    flex-direction: column;\n    box-sizing: border-box;\n    cursor: auto !important;\n    .popupDetails {\n      display: flex;\n      flex-direction: row;\n      align-items: center;\n      gap: 12px;\n      padding: 16px;\n      width: 100%;\n      max-width: 100%;\n      box-sizing: border-box;\n      min-height: 69.57px;\n      background-color: $timedetailsGrey;\n    }\n    .popupUserIcon {\n      width: 37.57px;\n      height: 37.57px;\n      flex-shrink: 0;\n      object-fit: contain;\n    }\n    .popupUserInfo {\n      display: flex;\n      flex-direction: column;\n      gap: 4px;\n      h4 {\n        margin: 0;\n        @include volteMedium;\n        font-size: $font-size-md-medium;\n        font-weight: 700;\n        line-height: 16px;\n        color: #030D14;\n      }\n      p {\n        margin: 0;\n        @include volteMedium;\n        font-size: $font-size-sm-base;\n        font-weight: $font-weight-normal;\n        line-height: 16px;\n        color: #030D14;\n      }\n    }\n    .popupBody {\n      display: flex;\n      flex-direction: column;\n      align-items: flex-start;\n      gap: 24px;\n      width: 100%;\n      padding: 24px 16px;\n      box-sizing: border-box;\n    }\n    .infoBlock {\n      display: flex;\n      flex-direction: column;\n      align-items: flex-start;\n      gap: 8px;\n      width: 100%;\n    }\n    .title {\n      margin: 0;\n      @include volteMedium;\n      font-size: $font-size-md-medium;\n      font-weight: 600;\n      line-height: 16px;\n      color: $darkGreyText;\n    }\n    .dtAccess {\n      display: flex;\n      flex-direction: row;\n      gap: 4px;\n      align-items: center;\n      width: 100%;\n      color: $darkGreyText;\n      .display {\n        margin: 0;\n        max-width: 262px;\n        @include volteMedium;\n        font-size: $font-size-sm-base;\n        font-weight: $font-weight-normal;\n        line-height: 16px;\n        color: $darkGreyText;\n      }\n      .toggle {\n        margin: 0;\n        display: flex;\n        align-items: center;\n        color: #0066CC;\n        @include volteMedium;\n        font-size: $font-size-sm-base;\n        font-weight: 600;\n        line-height: 16px;\n        cursor: pointer;\n      }\n    }\n    .popupLogout {\n      display: flex;\n      flex-direction: row;\n      align-items: center;\n      width: 100%;\n      padding: 0;\n      cursor: pointer;\n      background: transparent;\n      border: 0;\n\n      &:focus-visible {\n        outline: 2px solid #0066CC;\n        outline-offset: 3px;\n        border-radius: 6px;\n      }\n\n      p {\n        margin: 0;\n        @include volteMedium;\n        font-size: $font-size-md-medium;\n        font-weight: 600;\n        line-height: 16px;\n        color: #0066CC;\n      }\n    }\n    .display {\n      margin: 0;\n      @include volteMedium;\n      font-size: $font-size-sm-base;\n      font-weight: $font-weight-normal;\n      line-height: 16px;\n      color: #030D14;\n    }\n  }\n  @include sm {\n    display: none;\n  }\n}\n.sideMenuOptions {\n  min-height: 64px;\n  display: none;\n  @media (max-width: 848px) {\n    display: flex;\n    flex-direction: row;\n    gap: 16px;\n    align-items: center;\n    width: 100%;\n    cursor: pointer;\n    p {\n      font-size: $font-size-sm-base;\n      font-weight: $font-weight-normal;\n      color: #030D14;\n      margin-bottom: 0;\n    }\n  }\n}\n\n.menuSide {\n  @extend .navlinks;\n  cursor: default;\n  @media (max-width: 848px) {\n    position: fixed;\n    top: 68px;\n    right: 0;\n    left: auto;\n    bottom: 0;\n    height: calc(100vh - 68px);\n    width: 86vw;\n    max-width: 360px;\n    background-color: $white;\n    color: $black;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    z-index: 999;\n    visibility: visible;\n    overflow-y: auto;\n    overflow-x: auto;\n    max-height: calc(100vh - 68px);\n    min-height: 0;\n    overscroll-behavior: contain;\n    -webkit-overflow-scrolling: touch;\n    padding: 16px;\n    margin-right: 0;\n    border-radius: 16px 0 0 16px;\n    box-shadow: -6px 0px 24px rgba(0, 0, 0, 0.14);\n    top: 70px;\n  }\n}\n.userName {\n  font-size: 20px !important;\n  font-weight: 900 !important;\n  @include sm {\n    font-size: 16px !important;\n  }\n}\n.username {\n  margin-right: 180px;\n  cursor: pointer;\n\n  @include sm {\n    margin-right: 0px;\n    padding-bottom: 4px !important;\n  }\n\n  .userName {\n    font-size: 20px !important;\n    font-weight: 900 !important;\n    @include sm {\n      font-size: 16px !important;\n    }\n  }\n}\n.headerbottom {\n  width: 100%;\n  height: 56px;\n  display: flex;\n  justify-content: space-between;\n  // padding-left: 180px;\n  align-items: center;\n  background-color: $primaryBlue;\n  p {\n    margin-bottom: 0px !important;\n    font-weight: $font-weight-normal;\n    font-size: $font-size-sm-base;\n    color: $white;\n  }\n  .hamMenu {\n    display: none;\n  }\n  @include sm {\n    height: 60px;\n    justify-content: flex-end;\n    .hamMenu {\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      align-items: center;\n      gap: 4px;\n      margin-left: 18px;\n      margin-right: auto;\n    }\n    .hamMenu div {\n      width: 20px;\n      height: 2px;\n      border-radius: 2px;\n      background-color: $white;\n    }\n    p {\n      margin-right: 16px;\n      font-size: $font-size-md-medium;\n      margin-bottom: 0 !important;\n    }\n  }\n}\n.headerSidebar {\n  @extend .headerbottom;\n  @include sm {\n    position: fixed;\n    background-color: $primaryBlue;\n    display: flex;\n    flex-direction: column;\n    height: 170px;\n    width: 100%;\n    justify-content: space-around;\n    z-index: 999;\n    div,\n    p {\n      width: 100%;\n      display: flex;\n    }\n    .hamMenu {\n      display: flex;\n      justify-content: flex-end;\n      align-items: flex-end;\n      margin-left: 0;\n      position: absolute;\n      top: 22px;\n      right: 22px;\n    }\n    p {\n      font-size: $font-size-md-medium;\n      position: absolute;\n      bottom: 60px;\n      left: 16px;\n      width: auto;\n    }\n    .countryNameMbl {\n      display: none;\n    }\n  }\n}\n.menuIcons {\n  display: none;\n  @include sm {\n    display: block;\n  }\n}\n.menuSide {\n  @media (max-width: 848px) {\n    border-radius: 16px 0 0 16px;\n    padding-top: 16px;\n    position: fixed;\n    height: calc(100vh - 68px);\n    padding-left: 16px;\n    overflow-y: auto;\n    overflow-x: auto;\n    max-height: calc(100vh - 68px);\n    min-height: 0;\n    overscroll-behavior: contain;\n    -webkit-overflow-scrolling: touch;\n    z-index: 2000;\n    gap: 12px;\n  }\n}\n.logout {\n  @include sm {\n    display: none;\n  }\n}\n.logout_blue {\n  display: none;\n  @include sm {\n    display: block;\n  }\n}\n\n.userHeaderMbl {\n  display: none;\n\n  @include sm {\n    display: block;\n  }\n}\n\n.userHeaderDesktop {\n  display: block;\n  margin-left: 180px;\n  cursor: pointer;\n\n  @include sm {\n    display: none;\n  }\n}\n\n.headerbottom {\n  .backButton {\n    p {\n      font-size: 16px;\n    }\n\n    @include sm {\n      display: none;\n    }\n  }\n\n  // @include sm {\n  //   display: none;\n  // }\n}\n\n.dropdownConatiner {\n  display: flex;\n  gap: 16px;\n  height: 100%;\n  padding: 0px 8px;\n  align-items: center;\n  margin-left: 180px;\n\n  .dropdownWrapper {\n    display: flex;\n    height: 100%;\n  }\n\n  @include sm {\n    flex-direction: column !important;\n    display: none;\n  }\n\n  .dropdownselected {\n    background: $secondryBlue;\n    border-bottom: 3px solid white;\n    span {\n      font-weight: 600;\n    }\n  }\n\n  .dropdown {\n    position: relative;\n    height: 100%;\n    align-items: center;\n    display: flex;\n\n    @include sm {\n      flex-direction: column !important;\n    }\n\n    span {\n      color: white;\n      font-size: 14px;\n      padding: 0px 8px;\n\n      @include sm {\n        color: black;\n      }\n    }\n    .dropdownBody {\n      position: absolute;\n      z-index: 1;\n      background: $primaryBlue;\n      border-radius: 8px;\n      padding: 1rem 0px;\n      display: flex;\n      width: 322px;\n      flex-direction: column;\n      align-items: flex-start;\n      box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;\n      top: 90%;\n      z-index: 9999;\n\n      .dropdownOptions:hover {\n        background-color: $secondryBlue;\n        font-weight: 600;\n      }\n      .dropdownOptions {\n        font-size: 14px;\n        font-weight: 400;\n        color: white;\n        width: 100%;\n        padding: 8px 1rem;\n      }\n    }\n  }\n}\n\n.SMOMobileView {\n  min-height: 64px;\n  background: transparent;\n  border: 0;\n  width: 100%;\n  text-align: left;\n\n  &:focus-visible {\n    outline: 2px solid #0066CC;\n    outline-offset: 4px;\n    border-radius: 6px;\n  }\n}\n\n.dropdownMobile {\n  flex-direction: column !important;\n  gap: 0px !important;\n  height: max-content;\n  justify-content: flex-start;\n  font-size: 14px !important;\n  align-items: flex-start !important;\n  width: 100%;\n\n  .dropdownHeading {\n    margin-left: 0px;\n    min-height: 64px;\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n    .dropdownHeadingName {\n      flex-basis: 75%;\n    }\n    .dropdownHeadingArrow {\n      flex-basis: 25%;\n      justify-content: center;\n    }\n  }\n\n  .dropdownArrowOpen {\n    transform: rotate(-90deg);\n  }\n\n  .dropdownArrowClose {\n    transform: rotate(90deg);\n  }\n\n  span {\n    width: 100%;\n  }\n\n  .dropdownBody {\n    flex-direction: column !important;\n    gap: 0px !important;\n    overflow: scroll;\n    width: calc(100% + 16px);\n    margin-left: -16px !important;\n\n    .dropdownOptions {\n      margin: 0px !important;\n      width: 100%;\n      padding-left: calc(2.5rem + 16px);\n      min-height: 48px;\n      div {\n        min-height: 48px;\n      }\n    }\n    .dropdownSelected {\n      background: $timedetailsGrey;\n    }\n  }\n}\n.navLinkSelected {\n  height: 100%;\n  padding: 0px 8px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  font-weight: 600;\n  // border-bottom: 6px solid $timedetailsGrey;\n  // box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.10);\n  background-color: $secondryBlue !important;\n  position: relative;\n}\n.navLinkSelected::after {\n  content: \"\";\n  border: 3px solid $timedetailsGrey;\n  position: absolute;\n  bottom: -2px;\n  width: 102%;\n  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.1);\n}\n.adminDropdown {\n  position: relative;\n  img:last-child {\n    position: absolute;\n    right: 16px;\n    transform: rotate(90deg);\n    transition: transform 0.1s ease-in-out;\n  }\n  .invertArrow {\n    transform: rotate(-90deg) !important;\n  }\n}\n.adminDropdownOptions {\n  display: flex;\n  flex-direction: column !important;\n  justify-content: center;\n  align-items: flex-start !important;\n  padding-left: 38px;\n  // gap: 32px !important;\n  p {\n    height: 40px;\n    display: flex;\n    align-items: center;\n  }\n}\n\n.dropdownCountry {\n  width: auto;\n  min-width: fit-content;\n  max-width: fit-content;\n  flex-shrink: 0;\n  @include sm {\n    width: 60px;\n  }\n  @media (max-width: 848px) {\n    min-width: 210px;\n    max-width: 260px;\n  }\n\n  .dropdownControl {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    flex-wrap: nowrap;\n    gap: 0px;\n    height: 100%;\n    padding: $spacing-zero;\n    background-color: $white;\n    border: none;\n    outline: none;\n    width: auto;\n    overflow: visible;\n    cursor: pointer;\n    &:hover {\n      border: none;\n      box-shadow: none;\n      outline: none;\n    }\n\n    &:focus-visible {\n      outline: 2px solid #0066CC;\n      outline-offset: 2px;\n      border-radius: 6px;\n    }\n    @media (max-width: 848px) {\n      min-height: 40px;\n    }\n    .countryName {\n      border-right: 0;\n      padding: 0 4px 0 4px;\n      flex-wrap: nowrap;\n      .nameOption {\n        font-size: $font-size-md-xtraLarge;\n        font-weight: $font-weight-normal;\n        color: #030D14;\n        margin: 0;\n        line-height: 1.2;\n        white-space: nowrap;\n      }\n    }\n\n    .dropdownArrow {\n      div {\n        padding: 0;\n        color: #0066CC;\n        display: flex;\n        align-items: center;\n      }\n      div::after {\n        content: \"\";\n        width: 20px;\n        height: 20px;\n        display: block;\n        background: url(\"../../../assets/images/DropdownArrow.svg\") center/contain no-repeat;\n      }\n      svg {\n        display: none !important;\n      }\n    }\n\n    .dropdownText {\n      width: 100%;\n      max-width: 100%;\n      min-width: 0;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      font-size: $font-size-md-xtraLarge;\n      font-weight: $font-weight-normal;\n      color: #030D14;\n      @include volteMedium;\n    }\n  }\n\n  .seperator {\n    display: none;\n  }\n\n  .menu {\n    width: fit-content;\n    overflow: visible;\n    border-radius: 5px;\n    z-index: 99999;\n    @include sm {\n      position: absolute;\n      right: 15%;\n    }\n    @media (max-width: 848px) {\n      position: absolute;\n      right: 0;\n      z-index: 99999;\n    }\n  }\n\n  .menuList {\n    padding: 0;\n    border-radius: 5px;\n  }\n\n  .menuOption {\n    min-width: 100%;\n    background-color: $white;\n    width: fit-content;\n    padding: 4px 8px;\n    cursor: pointer;\n    border-bottom: none;\n    .countryName {\n      border-right: 0;\n      padding: 0 4px;\n      flex-wrap: nowrap;\n      .nameOption {\n        font-size: $font-size-md-medium;\n        font-weight: $font-weight-normal;\n        margin: 0;\n        line-height: 1.2;\n        color: $black;\n        white-space: nowrap;\n      }\n    }\n\n    &:hover {\n      background-color: $timedetailsGrey;\n    }\n    .selected {\n      background-color: $timedetailsGrey;\n    }\n  }\n}\n\n.dropdownArrowHidden {\n  display: none !important;\n}\n\n\n\n","﻿// Color codes here.\n$headerBlue:#275CE6;\n$headerBorder:#5588F7;\n$primaryBlue:#275CE6;\n$secondryBlue:#5588F7;\n$white:#FFFFFF;\n$tertiaryGrey:#676E72;\n$errorRed: #D52F3D;\n$progressRed:#E43263;\n$errorRed: #D52F3D;\n$progressGreen:#59B876;\n$progressCircleGrey:#9496A0;\n$black:#000000;\n$timedetailsGrey:#F3F7FD;\n$buttonbgBlue:#5588F7;\n$inputBorder:#CCCFD0;\n$buttonDisableBg:#E5E6E7;\n$buttonDisableText:#999EA1;\n$errorMessageRed:#FF5C83;\n$darkGreyText:#333C43;\n$tableHeader:#F6FCFF;\n$LandingPageBlue:#1E49B9;\n$secondary_lightish:#E1ECF5;\n$opTabViewDisabled:#F2F3F3;\n$otpGreyText:#B3B6C5;\n$otpErrorRed:#D52F3D;\n$oddTableRow: #f8f9fc;\n$agTableRow: #f3f3f3;\n$scrollbar: #888;\n$scrollbarHover: #555;\n$scrollbarTrack: #f1f1f1;\n$dropdownListColor: #f0f0f0;\n$dropdownShadow: #6123E70F;\n$disableButton : #cccccc;\n$progressContainer: #e0e0e0;\n// Font Sizes\n$font-size-xs-small: 10px;\n$font-size-sm-small: 12px;\n$font-size-sm-base: 14px;\n$font-size-md-medium: 16px;\n$font-size-md-large: 18px;\n$font-size-md-xtraLarge: 20px;\n$font-size-md-xLarge: 22px;\n$font-size-lg-medium: 24px;\n$font-size-xl-large: 32px;\n$font-size-xl-xtraLarge: 40px;\n$font-size-xl-medium: 28px;\n\n// Font weights\n$font-weight-normal: 400;\n$font-weight-medium: 500;\n$font-weight-semibold: 600;\n$font-weight-bold: 700;\n\n// Font Styles\n$font-style: 'Unilever Desire';\n\n// Line Height\n$line-height-medium: 16px;\n\n// Spacing\n$spacing-zero: 0px;\n$spacing-xs: 10px;\n$spacing-sm: 12px;\n$spacing-sm-m: 14px;\n$spacing-md: 16px;\n$spacing-md-m: 18px;\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainHeader": `LandingHeader_mainHeader__iqQt9`,
	"mainHeaderPassive": `LandingHeader_mainHeaderPassive__6ljlN`,
	"header": `LandingHeader_header__WSYV4`,
	"countryName": `LandingHeader_countryName__8zo6U`,
	"name": `LandingHeader_name__o8YpM`,
	"countryLogo": `LandingHeader_countryLogo__z6ise`,
	"countryNameMbl": `LandingHeader_countryNameMbl__I9kfJ`,
	"headertop": `LandingHeader_headertop__Llsv2`,
	"hamburgerBtn": `LandingHeader_hamburgerBtn__Mwfze`,
	"dttReports": `LandingHeader_dttReports__xRsOp`,
	"backArrow": `LandingHeader_backArrow__JuNoJ`,
	"logoIconContainer": `LandingHeader_logoIconContainer__VBQCN`,
	"logoIcon": `LandingHeader_logoIcon__3CMUf`,
	"logoText": `LandingHeader_logoText__EGElI`,
	"navlinks": `LandingHeader_navlinks__AYEoq`,
	"menuSide": `LandingHeader_menuSide__tWU81`,
	"headerDivider": `LandingHeader_headerDivider__C3BDB`,
	"profileAvatar": `LandingHeader_profileAvatar__4UIGV`,
	"profileAvatarInMenu": `LandingHeader_profileAvatarInMenu__o9wU9`,
	"inlineProfilePanel": `LandingHeader_inlineProfilePanel__jDHXS`,
	"inlineProfileHeader": `LandingHeader_inlineProfileHeader__oQ6x8`,
	"inlineProfileIcon": `LandingHeader_inlineProfileIcon__Fvts8`,
	"inlineProfileInfo": `LandingHeader_inlineProfileInfo__rxSRL`,
	"inlineProfileBody": `LandingHeader_inlineProfileBody__KQ35m`,
	"inlineInfoBlock": `LandingHeader_inlineInfoBlock__8QsNB`,
	"inlineTitle": `LandingHeader_inlineTitle__qT9CI`,
	"inlineDtAccess": `LandingHeader_inlineDtAccess__JFPWi`,
	"inlineDisplay": `LandingHeader_inlineDisplay__aHFej`,
	"inlineToggle": `LandingHeader_inlineToggle__zqGgv`,
	"inlineLogout": `LandingHeader_inlineLogout__ewIg5`,
	"profileIcon": `LandingHeader_profileIcon__0IfmL`,
	"popupModal": `LandingHeader_popupModal__rtaTq`,
	"popup": `LandingHeader_popup__yoe6+`,
	"popupDetails": `LandingHeader_popupDetails__dzkjD`,
	"popupUserIcon": `LandingHeader_popupUserIcon__A2xoZ`,
	"popupUserInfo": `LandingHeader_popupUserInfo__zguqT`,
	"popupBody": `LandingHeader_popupBody__95VGG`,
	"infoBlock": `LandingHeader_infoBlock__Bnl1S`,
	"title": `LandingHeader_title__EGtv1`,
	"dtAccess": `LandingHeader_dtAccess__ov8vb`,
	"display": `LandingHeader_display__FpFLc`,
	"toggle": `LandingHeader_toggle__-mSwa`,
	"popupLogout": `LandingHeader_popupLogout__bqlcq`,
	"sideMenuOptions": `LandingHeader_sideMenuOptions__iu59s`,
	"userName": `LandingHeader_userName__Nc2+q`,
	"username": `LandingHeader_username__FmzfW`,
	"headerbottom": `LandingHeader_headerbottom__6MBUS`,
	"headerSidebar": `LandingHeader_headerSidebar__O6+cf`,
	"hamMenu": `LandingHeader_hamMenu__h3l2Z`,
	"menuIcons": `LandingHeader_menuIcons__qQpou`,
	"logout": `LandingHeader_logout__wCX5w`,
	"logout_blue": `LandingHeader_logout_blue__Gzipb`,
	"userHeaderMbl": `LandingHeader_userHeaderMbl__ENplN`,
	"userHeaderDesktop": `LandingHeader_userHeaderDesktop__puXgz`,
	"backButton": `LandingHeader_backButton__jpK3i`,
	"dropdownConatiner": `LandingHeader_dropdownConatiner__2TZ8c`,
	"dropdownWrapper": `LandingHeader_dropdownWrapper__bapbM`,
	"dropdownselected": `LandingHeader_dropdownselected__L8W55`,
	"dropdown": `LandingHeader_dropdown__XvCUm`,
	"dropdownBody": `LandingHeader_dropdownBody__UPKTt`,
	"dropdownOptions": `LandingHeader_dropdownOptions__ceFP+`,
	"SMOMobileView": `LandingHeader_SMOMobileView__Q+Nvb`,
	"dropdownMobile": `LandingHeader_dropdownMobile__Evlmu`,
	"dropdownHeading": `LandingHeader_dropdownHeading__5Uhe6`,
	"dropdownHeadingName": `LandingHeader_dropdownHeadingName__BuYZY`,
	"dropdownHeadingArrow": `LandingHeader_dropdownHeadingArrow__xlVSk`,
	"dropdownArrowOpen": `LandingHeader_dropdownArrowOpen__yKeps`,
	"dropdownArrowClose": `LandingHeader_dropdownArrowClose__SYk5X`,
	"dropdownSelected": `LandingHeader_dropdownSelected__qgxoH`,
	"navLinkSelected": `LandingHeader_navLinkSelected__UWqIc`,
	"adminDropdown": `LandingHeader_adminDropdown__B11SS`,
	"invertArrow": `LandingHeader_invertArrow__o-YrC`,
	"adminDropdownOptions": `LandingHeader_adminDropdownOptions__xuOBS`,
	"dropdownCountry": `LandingHeader_dropdownCountry__G98p8`,
	"dropdownControl": `LandingHeader_dropdownControl__8T-SU`,
	"nameOption": `LandingHeader_nameOption__OCLv2`,
	"dropdownArrow": `LandingHeader_dropdownArrow__jBYvj`,
	"dropdownText": `LandingHeader_dropdownText__jiaCR`,
	"seperator": `LandingHeader_seperator__EfkFC`,
	"menu": `LandingHeader_menu__kf0Us`,
	"menuList": `LandingHeader_menuList__-jF0A`,
	"menuOption": `LandingHeader_menuOption__gvQFM`,
	"selected": `LandingHeader_selected__k7y7O`,
	"dropdownArrowHidden": `LandingHeader_dropdownArrowHidden__BgXTz`
};
export default ___CSS_LOADER_EXPORT___;
